import axios from 'axios';
import {
    GET_FEATURED_ITEMS,
    ADD_FEATURED_ITEM,
    DELETE_FEATURED_ITEM,
    UPDATE_FEATURED_ITEM,
    FEATURED_ITEMS_LOADING,
    FEATURED_ITEMS_ERROR
} from '../Constants/FeaturedItemTypes';

// Get all featured items
export const getFeaturedItems = (all = false) => async (dispatch) => {
    dispatch({ type: FEATURED_ITEMS_LOADING });
    try {
        const res = await axios.get(all ? '/api/featured?all=true' : '/api/featured');
        dispatch({
            type: GET_FEATURED_ITEMS,
            payload: res.data.data
        });
    } catch (error) {
        dispatch({
            type: FEATURED_ITEMS_ERROR,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        });
    }
};

// Add a new featured item
export const addFeaturedItem = (itemData) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorised': localStorage.getItem('token') // assuming admin token
            }
        };
        const res = await axios.post('/api/featured', itemData, config);
        dispatch({
            type: ADD_FEATURED_ITEM,
            payload: res.data.data
        });
    } catch (error) {
        dispatch({
            type: FEATURED_ITEMS_ERROR,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        });
    }
};

// Delete a featured item
export const deleteFeaturedItem = (id) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Authorised': localStorage.getItem('token') // assuming admin token
            }
        };
        await axios.delete(`/api/featured/${id}`, config);
        dispatch({
            type: DELETE_FEATURED_ITEM,
            payload: id
        });
    } catch (error) {
        dispatch({
            type: FEATURED_ITEMS_ERROR,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        });
    }
};
// Update a featured item
export const updateFeaturedItem = (id, itemData) => async (dispatch) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorised': localStorage.getItem('token')
            }
        };
        const res = await axios.put(`/api/featured/${id}`, itemData, config);
        dispatch({
            type: UPDATE_FEATURED_ITEM,
            payload: res.data.data
        });
    } catch (error) {
        dispatch({
            type: FEATURED_ITEMS_ERROR,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message
        });
    }
};
